import React, { useState } from 'react';
import ActivityFeed from './ActivityFeed';
import AlertsWidget from './AlertsWidget';
import TrendChart from './TrendChart';
import * as dashboardApi from '../../../api/dashboardApi';

const AlertsTabsWidget: React.FC<{
    recentRegulations: dashboardApi.RegulationSummary[];
    isLoadingRegulations: boolean;
    onRegulationClick: (regulation: dashboardApi.RegulationSummary) => void;
    trendData: dashboardApi.TrendDataPoint[];
    isLoadingTrends: boolean;
}> = ({ recentRegulations, isLoadingRegulations, onRegulationClick, trendData, isLoadingTrends }) => {
    const [tab, setTab] = useState<'alerts' | 'feed' | 'all' | 'chart'>('alerts');
    return (
        <div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                <button onClick={() => setTab('alerts')} style={{ fontWeight: tab === 'alerts' ? 700 : 400 }}>Active Alerts</button>
                <button onClick={() => setTab('feed')} style={{ fontWeight: tab === 'feed' ? 700 : 400 }}>Recent Activity Feed</button>
                <button onClick={() => setTab('all')} style={{ fontWeight: tab === 'all' ? 700 : 400 }}>All Regulations</button>
                <button onClick={() => setTab('chart')} style={{ fontWeight: tab === 'chart' ? 700 : 400 }}>Chart</button>
            </div>
            <div>
                {tab === 'alerts' && (
                    <AlertsWidget regulations={recentRegulations} isLoading={isLoadingRegulations} onRegulationClick={onRegulationClick} />
                )}
                {tab === 'feed' && (
                    <ActivityFeed regulations={recentRegulations} isLoading={isLoadingRegulations} onRegulationClick={onRegulationClick} />
                )}
                {tab === 'all' && (
                    <ActivityFeed regulations={recentRegulations} isLoading={isLoadingRegulations} onRegulationClick={onRegulationClick} />
                )}
                {tab === 'chart' && (
                    <TrendChart data={trendData} isLoading={isLoadingTrends} totalRegulations={undefined} />
                )}
            </div>
        </div>
    );
};

export default AlertsTabsWidget;
